/* ワンドライ W-A01（ストアのテーマに載せた版）
   1) 見出しの明朝化  2) シェア  3) 購入欄（セット/サイズ/色・定期便・カートポップアップ） */
(function () {
  'use strict';
  var root = document.getElementById('wa01');
  if (!root) return;
  var yen = function (n) { return '¥' + Math.round(n).toLocaleString('ja-JP'); };

  /* ================= 見出しの印付け ================= */
  function markHeads() {
    root.querySelectorAll('p,h1,h2,h3,h4,h5,h6,span,div').forEach(function (e) {
      if (e.classList.contains('wd-head')) return;
      if (e.children.length && [].some.call(e.children, function (c) { return c.textContent.trim(); })) return;
      var cs = getComputedStyle(e), fs = parseFloat(cs.fontSize), fw = parseInt(cs.fontWeight) || 400;
      if (fs < 22 || fw < 600) return;
      var t = (e.innerText || '').trim();
      if (!t || t.length > 70) return;
      e.classList.add('wd-head');
    });
  }

  /* ================= シェア ================= */
  var SHARE = [
    { key: 'orig-c219981f', name: 'Facebookでシェア', url: function (u) { return 'https://www.facebook.com/sharer/sharer.php?u=' + u; } },
    { key: 'orig-88e40028', name: 'Xでポスト', url: function (u, t) { return 'https://twitter.com/intent/tweet?url=' + u + '&text=' + t; } },
    { key: 'orig-a357d720', name: 'LINEで送る', url: function (u, t) { return 'https://social-plugins.line.me/lineit/share?url=' + u + '&text=' + t; } },
    { key: 'orig-6656a87b', name: 'リンクをコピー', copy: true }
  ];
  var toastEl = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.style.cssText = 'position:fixed;left:50%;bottom:110px;transform:translateX(-50%);background:#1c1b18;' +
        'color:#fff;padding:10px 18px;border-radius:999px;font-size:14px;z-index:2147483000;opacity:0;' +
        'transition:opacity .2s;pointer-events:none;max-width:88vw;text-align:center';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.style.opacity = '1';
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toastEl.style.opacity = '0'; }, 2000);
  }
  function wireShare() {
    var u = encodeURIComponent(location.href.split('#')[0]);
    var t = encodeURIComponent((document.title || '').split(' – ')[0]);
    root.querySelectorAll('picture,img').forEach(function (el) {
      var img = el.tagName === 'IMG' ? el : el.querySelector('img');
      if (!img) return;
      var src = img.getAttribute('src') || '';
      var hit = SHARE.filter(function (s) { return src.indexOf(s.key) >= 0; })[0];
      if (!hit) return;
      var box = el.tagName === 'PICTURE' ? el : (el.closest('picture') || el);
      if (box.dataset.wa01Share) return;
      box.dataset.wa01Share = '1';
      box.style.cursor = 'pointer';
      box.setAttribute('role', 'button');
      box.setAttribute('tabindex', '0');
      box.setAttribute('aria-label', hit.name);
      var go = function (ev) {
        ev.preventDefault(); ev.stopPropagation();
        if (hit.copy) {
          var link = location.href.split('#')[0];
          if (navigator.share) { navigator.share({ title: document.title, url: link }).catch(function () {}); return; }
          if (navigator.clipboard) navigator.clipboard.writeText(link).then(function () { toast('リンクをコピーしました'); });
          else toast(link);
          return;
        }
        window.open(hit.url(u, t), '_blank', 'noopener,width=600,height=640');
      };
      box.addEventListener('click', go);
      box.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') go(e); });
    });
  }

  /* ================= 購入欄（英語版カード＋商品ページと同じ 色/サイズ/定期便） ================= */
  var SUB_RATE = 0.85, SUB_MONTHLY = 5890;
  var PLAN = 3754655879;                  // Seal 定期便：請求・配送とも30日ごと
  var CARE = 45873190666375;              // Wケア定期便（誘導30ml＋消臭100ml、2本で5,890円）
  var SUB_PROPS = { 'お届け内容': '誘導スプレー30ml×1＋消臭スプレー100ml×1',
                    'お届け周期': '30日ごと／2本合計5,890円' };
  var RETIRED = ['WANDRYSUB15', 'WANDRY3000', 'WANDRY15', 'WANDRY1000', 'WANDRY2000', 'WANDRY4000', 'W-SUMMER-057BCB58'];
  var ORDER = ['S', 'M', 'L'];
  var DOG = { S: '超小型犬', M: '小型〜中型犬', L: '中型〜大型犬' };
  var SIZE_IMG = 'https://cdn.shopify.com/s/files/1/0742/1758/6823/files/wandry-sizecmp-ja.jpg?width=1100';
  var COLOR_PHOTOS = {

    'グレー': 'https://cdn.shopify.com/s/files/1/0742/1758/6823/files/wandry-gallery-gray_a8ed961e-2422-4436-a8b3-57160f8610cf.jpg?v=1788523418',
    'ベージュ': 'https://cdn.shopify.com/s/files/1/0742/1758/6823/files/wandry-gallery-beige_33d8cb4c-a664-458b-9b57-a63b85d02baf.jpg?v=1788523418',
    'ホワイト': 'https://cdn.shopify.com/s/files/1/0742/1758/6823/files/wandry-gallery-white_0e2ccf9b-38e1-4a7b-9039-8436b69ae0d0.jpg?v=1788523418'
  };
  var state = { color: 'グレー', size: null, sub: true };
  var DATA = null, adding = false, busyBtn = null;

  function ec(name) { try { if (window.EC_MEASURE) window.EC_MEASURE.event(name); } catch (e) {} }
  function letterOf(s) { return String(s).split('（')[0].split('(')[0].trim(); }
  function dimOf(s) { var m = String(s).match(/[（(](.+?)[）)]/); return m ? m[1] : ''; }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function optIndex(d) {
    var idx = { color: 0, size: 1, set: 2 };
    (d.options || []).forEach(function (name, i) {
      if (/色|カラー/.test(name)) idx.color = i;
      else if (/サイズ/.test(name)) idx.size = i;
      else if (/枚|セット|数量/.test(name)) idx.set = i;
    });
    return idx;
  }
  function uniq(a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); }
  function qtyOf(s) { var m = String(s).match(/(\d+)/); return m ? +m[1] : 1; }
  function variantFor(sel) {
    var ix = DATA._ix;
    return DATA.variants.filter(function (v) {
      return v.opts[ix.color] === sel.color && v.opts[ix.size] === sel.size && v.opts[ix.set] === DATA._set;
    })[0];
  }

  function buildBuybox() {
    var host = document.getElementById('wa01-buy');
    var raw = document.getElementById('wa01-variants');
    if (!host || !raw || host.dataset.ready) return;
    try { DATA = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!DATA || !DATA.variants || !DATA.variants.length) return;
    DATA._ix = optIndex(DATA);
    var ix = DATA._ix;
    DATA.variants = DATA.variants.filter(function (v) { return Object.prototype.hasOwnProperty.call(COLOR_PHOTOS, v.opts[ix.color]); });
    var sets = uniq(DATA.variants.map(function (v) { return v.opts[ix.set]; }));
    DATA._set = sets.filter(function (s) { return qtyOf(s) === 6; })[0] || sets[sets.length - 1];
    var sizes = uniq(DATA.variants.map(function (v) { return v.opts[ix.size]; }));
    var colors = uniq(DATA.variants.map(function (v) { return v.opts[ix.color]; }));
    sizes.sort(function (a, b) { return ORDER.indexOf(letterOf(a)) - ORDER.indexOf(letterOf(b)); });
    state.size = sizes.filter(function (s) { return letterOf(s) === 'M'; })[0] || sizes[0];
    if (colors.indexOf(state.color) < 0) state.color = colors[0];
    host.dataset.ready = '1';

    document.getElementById('wa01-sizes').innerHTML = sizes.map(function (s) {
      var L = letterOf(s);
      return '<button type="button" class="wd-opt wd-opt--size" data-size="' + esc(s) + '">' +
             '<strong>' + L + '</strong><span>' + dimOf(s) + '</span>' +
             (DOG[L] ? '<small class="wdc-dog">' + DOG[L] + '</small>' : '') + '</button>';
    }).join('');
    sizeGuide(sizes);
    host.querySelectorAll('.wd-opt--color').forEach(function (b) {
      if (colors.indexOf(b.getAttribute('data-color')) < 0) b.remove();
    });

    host.addEventListener('click', function (e) {
      var s = e.target.closest('.wd-opt--size'), c = e.target.closest('.wd-opt--color');
      if (s) { state.size = s.getAttribute('data-size'); render(); return; }
      if (c) { state.color = c.getAttribute('data-color'); render(); return; }
    });
    var tgl = document.getElementById('wa01-subToggle');
    var title = document.querySelector('#wa01-sub .wd-sub__title');
    var flip = function (e) { e.preventDefault(); state.sub = !state.sub; render(); ec(state.sub ? 'sub_on' : 'sub_off'); };
    if (tgl) tgl.addEventListener('click', flip);
    if (title) title.addEventListener('click', flip);
    document.getElementById('wa01-add').addEventListener('click', addToCart);
    render();
  }

  function sizeGuide(sizes) {
    var row = document.querySelector('#wa01-variant .wd-variant__opts--size');
    row = row && row.closest('.wd-variant__row');
    if (!row || row.querySelector('.wdc-guide')) return;
    var link = document.createElement('button');
    link.type = 'button'; link.className = 'wdc-guide'; link.textContent = 'サイズガイド';
    link.setAttribute('aria-haspopup', 'dialog');
    row.querySelector('.wd-variant__label').appendChild(link);
    var dlg = document.createElement('dialog');
    dlg.className = 'wdc-dialog';
    dlg.setAttribute('aria-labelledby', 'wa01-guide-title');
    dlg.innerHTML = '<button type="button" class="wdc-close" aria-label="閉じる">×</button>' +
      '<h2 id="wa01-guide-title">サイズガイド</h2>' +
      '<img src="' + SIZE_IMG + '" alt="S・M・Lのパッドサイズ比較">' +
      '<div class="wdc-size-table">' + sizes.map(function (s) {
        var L = letterOf(s);
        return '<div><strong>' + L + '</strong><span>' + dimOf(s) + '</span><small>' + (DOG[L] || '') + '</small></div>';
      }).join('') + '</div>';
    document.body.appendChild(dlg);
    link.addEventListener('click', function () {
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
    });
    dlg.querySelector('.wdc-close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) {
      if (e.target !== dlg) return;
      var r = dlg.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
    });
  }

  function render() {
    var host = document.getElementById('wa01-buy');
    host.querySelectorAll('.wd-opt--size').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-size') === state.size); });
    host.querySelectorAll('.wd-opt--color').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-color') === state.color); });
    var set = function (id, t) { var e = document.getElementById(id); if (e) e.textContent = t; };
    set('wa01-colorName', state.color || '');
    var selectedPhoto = host.querySelector('.wab__img');
    if (selectedPhoto && COLOR_PHOTOS[state.color] && selectedPhoto.getAttribute('data-wandry-color') !== state.color) {
      selectedPhoto.removeAttribute('srcset'); selectedPhoto.removeAttribute('sizes');
      selectedPhoto.src = COLOR_PHOTOS[state.color];
      selectedPhoto.alt = 'ワンドライ ' + state.color + ' 洗える犬用トイレパッド';
      selectedPhoto.setAttribute('data-wandry-color', state.color);
    }
    set('wa01-sizeName', state.size ? letterOf(state.size) + ' ／ ' + dimOf(state.size) : '');

    var subBox = document.getElementById('wa01-sub'), tgl = document.getElementById('wa01-subToggle');
    if (subBox) subBox.classList.toggle('is-on', state.sub);
    if (tgl) tgl.setAttribute('aria-checked', state.sub ? 'true' : 'false');

    var v = variantFor(state);
    var cta = document.getElementById('wa01-add');
    if (!v || !v.available) {
      ['wa01-compare', 'wa01-save', 'wa01-unit', 'wa01-note'].forEach(function (id) { set(id, ''); });
      set('wa01-now', '在庫切れ');
      cta.disabled = true; cta.textContent = '在庫切れ';
      return;
    }
    var qty = qtyOf(DATA._set);
    var base = v.price / 100;
    var total = state.sub ? Math.round(base * SUB_RATE) : base;
    var delta = document.querySelector('#wa01-sub [data-wd-care-delta]');
    if(delta) delta.textContent = (Math.round(base * SUB_RATE) + SUB_MONTHLY - base).toLocaleString('ja-JP');
    var comp = v.compare ? v.compare / 100 : 0;
    set('wa01-compare', comp > total ? yen(comp) : '');
    set('wa01-now', yen(total));
    set('wa01-save', comp > total ? yen(comp - total) + 'お得' : '');
    set('wa01-unit', '1枚あたり' + yen(total / qty) + '。6枚そろえても、使い捨てシーツ1年分より安い計算です');
    cta.disabled = false;
    cta.textContent = qty + '枚セットを' + yen(total + (state.sub ? SUB_MONTHLY : 0)) + 'で購入する';
    set('wa01-note', '');
  }

  /* ---- カートは押した瞬間に開き、読み込みはカートの中で見せる ---- */
  function drawer() { return document.querySelector('cart-drawer'); }

  function openCart() {
    var cd = drawer(); if (!cd) return;
    if (typeof cd.open === 'function') { try { cd.open(); } catch (e) {} }
    cd.classList.add('animate', 'active');
    cd.style.setProperty('visibility', 'visible', 'important');
    document.body.classList.add('overflow-hidden');
  }

  function beginAdd() {
    adding = true;
    var btn = document.getElementById('wa01-add');
    if (btn) {
      busyBtn = { el: btn, disabled: btn.disabled, text: btn.textContent };
      btn.textContent = '';
      btn.classList.add('wd-add-busy');
      btn.setAttribute('aria-busy', 'true');
      var p = document.createElement('span');
      p.className = 'wd-add-progress';
      p.innerHTML = '<span class="wd-add-spinner" aria-hidden="true"></span><span>追加中…</span>';
      btn.appendChild(p);
    }
    var cd = drawer();
    if (cd) {
      cd.querySelectorAll('.wd-cart-add-error').forEach(function (e) { e.remove(); });
      cd.classList.remove('is-empty');
      cd.classList.add('wd-cart-pending');
      cd.setAttribute('aria-busy', 'true');
      var inner = cd.querySelector('.drawer__inner');
      if (inner && !inner.querySelector('.wd-cart-add-progress')) {
        var prog = document.createElement('div');
        prog.className = 'wd-cart-add-progress';
        prog.setAttribute('role', 'status');
        prog.setAttribute('aria-live', 'polite');
        prog.innerHTML = '<span class="wd-add-spinner" aria-hidden="true"></span>' +
                         '<strong>カートに追加中…</strong><span>商品と金額を更新しています</span>';
        inner.appendChild(prog);
      }
    }
    openCart();
  }

  function finishAdd() {
    if (busyBtn) {
      var btn = busyBtn.el;
      btn.classList.remove('wd-add-busy');
      btn.removeAttribute('aria-busy');
      btn.disabled = busyBtn.disabled;
      btn.textContent = busyBtn.text;
      busyBtn = null;
    }
    var cd = drawer();
    if (cd) {
      cd.classList.remove('wd-cart-pending');
      cd.removeAttribute('aria-busy');
      cd.querySelectorAll('.wd-cart-add-progress').forEach(function (e) { e.remove(); });
    }
    adding = false;
  }

  function addError(err) {
    var cd = drawer(), inner = cd && cd.querySelector('.drawer__inner');
    var msg = (err && err.message) || 'カートを更新できませんでした。カートの内容をご確認ください。';
    if (!inner) { toast(msg); return; }
    var box = document.createElement('p');
    box.className = 'wd-cart-add-error';
    box.setAttribute('role', 'alert');
    box.textContent = msg;
    if (window.WD_CART_SAFETY) WD_CART_SAFETY.recovery(box);
    inner.appendChild(box);
  }

  function post(u, b) {
    return fetch(u, { method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(b) });
  }
  var BUSY = 'ただいまカートが混み合っています。少し待ってから、もう一度お試しください。';
  function cartJson() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error(BUSY);
      return r.json().catch(function () { throw new Error(BUSY); });
    });
  }

  function clearLegacyDiscount() {
    return cartJson().then(function (c) {
      var codes = c.discount_codes || [];
      var legacy = function (d) { return RETIRED.indexOf(String(d.code).toUpperCase()) !== -1; };
      if (!codes.some(legacy)) return c;
      var keep = codes.filter(function (d) { return !legacy(d); }).map(function (d) { return d.code; });
      return post('/cart/update.js', { discount: keep.join(',') }).then(function (r) {
        if (!r.ok) throw new Error('割引情報を更新できませんでした。もう一度お試しください。');
        return c;
      });
    });
  }

  function badge() {
    return cartJson().then(function (c) {
      document.querySelectorAll('.cart-count-bubble span:first-child').forEach(function (s) {
        s.textContent = c.item_count; });
    }).catch(function () {});
  }

  function afterAdd(resp) {
    var cd = drawer();
    if (!cd) { location.href = '/cart'; return; }
    cd.classList.remove('is-empty');
    cd.classList.remove('wd-cart-pending');
    cd.querySelectorAll('.wd-cart-add-progress').forEach(function (e) { e.remove(); });
    if (!resp.sections || !resp.sections['cart-drawer'] || typeof cd.renderContents !== 'function') { location.assign('/cart'); return; }
    try { cd.renderContents(resp); } catch (e) { location.assign('/cart'); return; }
    openCart();
    badge();
    ec('cart_add_succeeded');
  }

  function performAdd(items, sub) {
    return clearLegacyDiscount().then(function (c) {
      var existing = (c.items || []).filter(function (i) {
        return i.variant_id === CARE && i.selling_plan_allocation &&
               i.selling_plan_allocation.selling_plan.id === PLAN; })[0];
      if (existing && sub) {
        // 同じ定期便が既に入っていれば増やさない（契約が二重にならないように）
        items = items.filter(function (i) { return i.id !== CARE; });
        return items;
      }
      if (existing && !sub) {
        return post('/cart/change.js', { id: existing.key, quantity: 0 }).then(function (r) {
          if (!r.ok) throw new Error('定期便の選択を更新できませんでした。もう一度お試しください。');
          return items;
        });
      }
      return items;
    }).then(function (list) {
      var cd = drawer();
      var body = { items: list };
      if (cd && typeof cd.getSectionsToRender === 'function') {
        try {
          body.sections = cd.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = location.pathname;
        } catch (e) {}
      }
      if (!body.sections) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      return Promise.resolve(window.WANDRY_AB ? window.WANDRY_AB.ensureCart() : false).then(function () { return post('/cart/add.js', body); });
    }).then(function (res) {
      if (!res.ok) {
        if (res.status === 429 || res.status >= 500) throw new Error(BUSY);
        return res.json().catch(function () { return {}; }).then(function (p) {
          throw new Error(p.description || 'カートに追加できませんでした。もう一度お試しください。');
        });
      }
      return res.json().catch(function () { throw new Error(BUSY); });
    }).then(function (resp) { afterAdd(resp); return true; });
  }

  function addToCart() {
    if (adding) return;
    var v = variantFor(state);
    if (!v || !v.available) return;
    var items = [{ id: v.id, quantity: 1 }];
    if (state.sub) items.push({ id: CARE, quantity: 1, selling_plan: PLAN, properties: SUB_PROPS });
    beginAdd();
    performAdd(items, state.sub).catch(addError).then(finishAdd, finishAdd);
  }

  function run() { markHeads(); wireShare(); buildBuybox(); }
  run();
  [300, 1200, 3000].forEach(function (d) { setTimeout(run, d); });
  var tid = null;
  new MutationObserver(function () { clearTimeout(tid); tid = setTimeout(run, 200); })
    .observe(root, { childList: true, subtree: true });
})();
